module.exports = __webpack_public_path__ + "img/Axe.417bace5.png";